<template>
	<db-col height="auto" class="form-field-wrapper" valign="middle" @click="clickHandler">
		<slot name="prefix-icon" />
		<db-label v-if="label" class="ellipsis" bold :width="textWidth" size="32" color="#333333" :class="['form-text', prefixIcon ? 'form-text-prefix-icon' : '']">{{label}}</db-label>
		<slot name="label-suffix" />
		<db-col height="auto" align="right" class="auto-fill" valign="middle"><slot /></db-col>
		<db-icon v-if="suffixIcon" :icon="suffixIcon" align="right" width="auto" class="field-icon" />
	</db-col>
</template>

<script>
	export default {
		name: 'form-field',
		
		props: {
			label: {
				type: String,
				default: ''
			},
			
			textWidth: {
				type: [String, Number],
				default: '200'
			},
			
			suffixIcon: {
				type: String,
				default: ''
			}
		},
		
		computed: {
			prefixIcon(){
				return !!this.$slots['prefix-icon']
			}
		},
		
		methods: {
			clickHandler(){
				this.$emit('click')
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	@import '../../../assets/styles/vars.scss';
	
	.form-field-wrapper{
		border-bottom: solid 2px #eee;
		padding: 12px 24px 12px 8px;
		
		&:last-child{
			border-bottom: none;
		}
		
		.form-text{
			padding-right: 16px;
			
			&.form-text-prefix-icon{
				margin-left: 8px;
			}
		}
		
		.h5font{
			color: $btn_info_color;
		}
		
		.field-icon{
			color: #C0C4CC;
			font-size: 36px;
		}
		
		.label-text{
			&.ellipsis{
				text-align: left;
			}
		}
	}
</style>
